module.exports = __webpack_public_path__ + "static/media/45.6f76fe72.jpg";